export default "__VITE_ASSET__mx2H4XYK__"